export default {
  'ec.system.name': 'Харбинская новая территория и платформа для зоны свободной торговли для России',
  'ec.system.slogan': '',
  'ec.system.copyright': '',
}